<template>
  <div class="isis-page__header md-layout">
    <div class="md-layout-item md-size-100">
      <div class="nav-link" @click="goToPreviousPage()">
        <i class="fas fa-chevron-left"></i>
        <span>{{ $t("task_management.edit_individual_task") }}</span>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card v-if="subtaskDetail">
        <md-card-content>
          <SubtaskForm
            mode="edit"
            type="individual"
            :subtask-data="subtaskDetail"
          ></SubtaskForm>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import SubtaskForm from "../Component/SubtaskForm";
import { hasHistory } from "@/helpers/utils";
import { service_names } from "../../../constants/Services";
export default {
  components: {
    SubtaskForm
  },
  data() {
    return {
      subtaskId: this.$route.params.id,
      subtaskDetail: null
    };
  },
  created() {
    this.$axios
      .get(`${service_names.school}/sub-task/${this.subtaskId}`)
      .then(({ data }) => {
        this.subtaskDetail = data;
      });
  },
  methods: {
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>
